<template>
  <div class="refund-history">
    <div class="container search-card">
      <md-card class="search">
        <div class="flex-s">
          <div class="s-input">
            <input-field :label="i18n.lbl_sum_refund()" v-model.trim="amount"  :clear="true"/>
          </div>
          <div class="s-input">
            <input-field :label="i18n.lbl_hash()" v-model.trim="hash"  :clear="true"/>
          </div>
          <md-button class="md-button btn md-primary md-theme-default md-yellow flex-btn s-input width-btn" :disabled="isLoading" @click="getList">
            <md-icon class="md-size-1x">search</md-icon>
          </md-button>
        </div>
      </md-card>
    </div>
    <div class="container container_40">
      <md-table>
        <md-table-row class="tx-history__row">
            <md-table-head>{{ i18n.lbl_id() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_temporary_wallet() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_refund_address() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_sum_refund() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_refund_balance() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_refund_date() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_refund_hash() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_refund_status() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_refund_number() }}</md-table-head>
        </md-table-row>
        <template v-if="formatList && !isLoading">
          <md-table-row class="tx-history__row" :class="{'grey': item.asset.endsWith('20D')}" v-for="item in formatList" :key="`refund-${item.id}`">
            <CopyVal :value="item.id" :valueToShow="item.id_short"/>
            <CopyVal :value="item.source_wallet" :valueToShow="item.source_wallet_short"/>
            <CopyVal :value="item.refund_wallet" :valueToShow="item.refund_wallet_short"/>
            <md-table-cell  class="tx-history__cell">{{ item.asset_big }}</md-table-cell>
            <md-table-cell  class="tx-history__cell">{{ item.source_balance }}</md-table-cell>
            <md-table-cell  class="tx-history__cell">{{ item.created_at }}</md-table-cell>
            <CopyVal :value="item.tx_hash" :valueToShow="item.tx_hash_short"/>
            <md-table-cell  class="tx-history__cell" :class="{
              'orange': item.status_formated === i18n.lbl_refund_pending(),
              'green': item.status_formated === i18n.lbl_refund_success(),
              'red': item.status_formated === i18n.lbl_refund_canceled(),
            }">
              {{ item.status_formated }}
            </md-table-cell>
            <md-table-cell  class="tx-history__cell">{{ item.order_no }}</md-table-cell>
          </md-table-row>
        </template>
        <md-table-row v-if="more">
          <md-table-cell colspan="10">
            <div class="tx-history__btn-outer">
              <md-button :disabled="isLoading" @click="showMore">{{ i18n.lbl_more() }}</md-button>
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { i18n } from '@js/i18n'
import { formatTokenDisplay, TOKEN_NETWORK_SUFFIXES } from '@utils/consts'
import InputField from '@com/fields/InputField'
import CopyVal from './CopyVal.vue'
import apiHelper from '@utils/cunstomInterseptor'
import CurrencyRound from '@com/mixins/currency.round.mixin'
export default {
  components: {InputField, CopyVal},
  mixins: [CurrencyRound],
  data () {
    return {
      i18n,
      limit: 10,
      offset: 0,
      isLoading: false,
      list: [],
      hash: '',
      amount: '',
      more: false
    }
  },
  async mounted () {
    await this.getList()
    this.more = this.list.length >= 10 && !this.isLoading
  },
  computed: {
    formatList () {
      if (this.list) {
        let formatted = this.list.map(el => {
          const asset = el.currency && TOKEN_NETWORK_SUFFIXES.includes(el.asset)
            ? `${el.currency}${el.asset}`
            : el.asset
          const token = formatTokenDisplay(asset)
          return {
            ...el,
            created_at: this.formatDate(el.created_at),
            asset_big: `${this.roundCurrency2(Number(el.refund_amount) / 1000000)} ${token}`,
            refund_amount: `${this.roundCurrency2(Number(el.refund_amount) / 1000000)}`,
            refund_commission: `${this.roundCurrency2(Number(el.refund_commission) / 1000000)}`,
            source_balance: `${this.roundCurrency2(Number(el.source_balance) / 1000000)} ${token}`,
            refund_wallet_short: this.shortenString(el.refund_wallet),
            source_wallet_short: this.shortenString(el.source_wallet),
            status_formated: this.formatStatus(el.status),
            id_short: this.shortenString(el.id),
            tx_hash_short: el.tx_hash ? this.shortenString(el.tx_hash) : '—'
          }
        })
        return formatted
      }
      return null
    },
  },
  methods: {
    async getList () {
      const amount = Number(this.amount) > 0 ? Number(this.amount) * 1000000 : ''
      this.offset = 0
      try {
        this.isLoading = true
        const { data } = await apiHelper.get(`/refund/list?limit=${this.limit}&offset=${this.offset}&refund_amount=${amount}&tx_hash=${this.hash}`)
        this.more = data.length >= 10
        this.list = data
      } catch(err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    async showMore () {
      const amount = Number(this.amount) > 0 ? Number(this.amount) * 1000000 : ''
      this.offset += 10
      try {
        this.isLoading = true
        const { data } = await apiHelper.get(`/refund/list?limit=${this.limit}&offset=${this.offset}&refund_amount=${amount}&tx_hash=${this.hash}`)
        this.more = data.length >= 10
        this.list = [...this.list, ...data]
      } catch(err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    formatStatus (status) {
      switch (status) {
        case 'pending':
          return this.i18n.lbl_refund_pending()
        case 'success':
          return this.i18n.lbl_refund_success()
        case 'failed':
          return this.i18n.lbl_refund_canceled()
      }
    },
    formatDate (date) {
      const d = new Date(date)
      const userLocale = navigator.language;
      const timeParts = new Date(date).toLocaleString(userLocale, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
      const yy = String(d.getFullYear()).slice(-2);
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');

      return `${yy}-${mm}-${dd} ${timeParts}`;
    },
    shortenString (str) {
      const maxLength = 10
      if (str.length <= maxLength) {
          return str
      }
      
      const keep = Math.floor((maxLength - 3) / 2)
      const start = str.slice(0, keep)
      const end = str.slice(-keep)
      return `${start}...${end}`
    },
    showCopySuccess () {
      EventDispatcher.dispatchShowSuccessEvent(i18n.dep_copied())
    }
  },
}
</script>

<style scoped lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';
  /deep/ .md-field {
    margin-top: 24px !important;
  }
  
  .tx-history__btn-outer {
    text-align: center;
  }
  .search-card {
    margin: 15px 0;
    margin-bottom: 40px;
    .search {
      padding: 0 15px;
      border-radius: 16px;
    }
    .search-row {
      display: flex;
      gap: 10px;
    }
    button.s-input {
      min-height: 58px;
    }
    .s-input:not(button):not(:has(.date-field)) {
      width: 100%;
    }
  }
  .flex-s {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .flex-btn {
    .md-icon {
      color: $default-light-white;
    }
    .md-icon-font {
      color: $default-black !important;
    }
  }
  .dnone {
    display: none;
  }
  .orange {
    color: $col-pending;
  }
  .green {
    color: $green;
  }
  .red {
    color: $error-red;
  }
  .grey {
    background-color: $gray_asset;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/refundHistory/RefundHistory.Index.vue